import React from 'react';
import { useSelector } from 'react-redux';
import { preLoadImagePath } from '../../helpers/images';

function ErrorsComponent() {
    const [errorReducer] = useSelector(state => [state.errorReducer]);


    const getErrorMessage = () => {
        // Show default error message for API 400 errors (timeout) or non-API errors
        if (errorReducer?.isApiError && errorReducer?.statusCode === 400) {
            // Default error message for 400 timeout errors
            return {
                title: 'Start på nytt!',
                message: 'For å fortsette må du skanne QR-koden på nytt og starte en ny forespørsel.',
                action: 'Åpne "Skann" i Vipps appen eller bruk mobilens kamera.'
            };
        }
        
        if (errorReducer?.isApiError) {
            return {
                title: 'Noe gikk galt',
                message: 'Kunne ikke koble til serveren.',
                action: <>Dette kan skyldes dårlig internettforbindelse eller at serveren er midlertidig utilgjengelig.<br />Sjekk internettforbindelsen din og prøv igjen.</>
            };
        }
        
        // Default error message
        return {
            title: 'Start på nytt!',
            message: 'For å fortsette må du skanne QR-koden på nytt og starte en ny forespørsel.',
            action: 'Åpne "Skann" i Vipps appen eller bruk mobilens kamera.'
        };
    };

    const errorInfo = getErrorMessage();

    return (
        <>
            <div id="warpper-body" className="wrapper-rounded-login">
                <div className="d-flex flex-direction-colomn h-100">
                    <div id="slogan" className="d-flex flex-direction-colomn align-item-center">
                        <h1>Lås opp</h1>
                        <h1>med <span className="orange-vipps"> vipps </span> </h1>
                    </div>

                    <div className="d-flex flex-direction-colomn align-item-center text-center mt-4">
                        <h3>{errorInfo.title}</h3>
                        <p>
                            {errorInfo.message}
                            {errorInfo.action && (
                                <>
                                    <br />
                                    <strong>{errorInfo.action}</strong>
                                </>
                            )}
                        </p>
                    </div>

                    <div className="d-flex align-item-center h-100">
                        <div className="align-item-left">
                            <img className="qr-code-scan-image" src={`${preLoadImagePath.qrCodeScan}`} alt="QR Scanner" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="lady-character-wrapper">
                <img className="lady-character-image" src={`${preLoadImagePath.ladyCharacter}`} alt="Lady Character" />
            </div>
        </>
    );
}

export { ErrorsComponent };